module.exports = __webpack_public_path__ + "static/media/burwood.d3540f23.png";